import DisplayBonus from 'components/DisplayBonus'

const BonusRewardThumbnail: React.FC<{ bonusImage: string; size?: number }> = ({ bonusImage, size = 24 }) => {
  return <DisplayBonus bonusImage={bonusImage} width={size} height={size} enableVerticalAlignment />
}

export default BonusRewardThumbnail
